import management from './management/index';

export default {
  management
}



// WEBPACK FOOTER //
// ./src/locales/no/page/artist/index.js